import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import IconFavorite from '@mui/icons-material/FavoriteOutlined';
import IconCopy from '@mui/icons-material/FileCopy';
import { Button, IconButton, Tooltip } from '@mui/material';

const CopyButton = ({ value, icon, iconButton = false, ...restProps }) => {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef(NaN);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const copyToClipboard = useCallback(
        (event) => {
            clearTimeout(timerRef.current);
            const textArea = document.createElement('textarea');

            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = '0';
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.value = String(value);
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('SelectAll');
            document.execCommand('copy');
            document.body.removeChild(textArea);
            event.target.focus();

            setCopied(true);
            timerRef.current = window.setTimeout(() => setCopied(false), 2000);
        },
        [value]
    );

    if (iconButton) {
        return (
            <Tooltip title={copied ? 'Copied' : 'Copy to clipboard'}>
                <IconButton size="small" {...restProps} onClick={copyToClipboard}>
                    {copied ? <IconFavorite /> : icon || <IconCopy />}
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <Button
            onClick={copyToClipboard}
            startIcon={copied ? <IconFavorite /> : icon || <IconCopy />}
            color="secondary"
        >
            {copied ? 'Copied!' : 'Copy'}
        </Button>
    );
};

CopyButton.propTypes = {
    icon: PropTypes.element,
    iconButton: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default CopyButton;
